{
    "locale": "en-US",
    "footer": {
        "service": "Service",
        "essential": "Essentials",
        "address": "Address",
        "tel": "Phone",
        "telfax": "Fax",
        "email": "Email"
    },
    "search": {
        "placeholder": "Enter any term.",
        "headline": "Search",
        "search": "Search",
        "search-for": "Search for {search}",
        "search-for-html": "Article search for",
        "count-hits": "{count} hits",
        "search-entries": "Search results"
    },
    "general": {
        "play": "play",
        "companyName": "Foundation for Family Businesses and Politics",
        "share": "Share",
        "to-profile": "To profile",
        "more-know": "Learn more",
        "contact-info": "Contact information",
        "All-news": "All news",
        "topic": "Topic",
        "all-positions": "All positions",
        "no-entries": "No entries",
        "no-entries-found": "No entries found",
        "read-more": "Read more",
        "sfu": "Stiftung Familienunternehmen und Politik",
        "pariser": "Pariser Platz 6a",
        "berlin": "10117 Berlin",
        "country": "Germany",
        "back": "Back",
        "not-found": "Page not found",
        "load-more": "Load more",
        "more": "More",
        "position": "Position",
        "opinion": "Opinion",
        "vlog": "Vlog",
        "inPress": "Press Coverage",
        "pressNotification": "Press Releases"
    }
}
